export function identityValidator(_: string, resolve: (isValid: boolean) => void) {
  resolve(true);
}
